import type { TypedDocumentNode } from '@apollo/client';
import { gql } from '@apollo/client';

import { useTokenBelongsToUser } from '@sorare/core/src/hooks/useTokenBelongsToUser';

import type { useIsCardDroppable_anyCard } from './__generated__/useIsCardDroppable.graphql.ts';

export const useIsCardDroppable = () => {
  const tokenBelongsToUser = useTokenBelongsToUser();

  return (anyCard: useIsCardDroppable_anyCard) => {
    const isOwner = tokenBelongsToUser(anyCard);
    const isUsedInLineup =
      anyCard.openedSo5Lineups.length > 0 || anyCard.liveSo5Lineup !== null;
    const hasSignedDropCardPrice = !!anyCard.signedDropCardPrice;

    const isDroppable = isOwner && hasSignedDropCardPrice;

    return { isDroppable, isUsedInLineup, isOwner, hasSignedDropCardPrice };
  };
};

useIsCardDroppable.fragments = {
  anyCard: gql`
    fragment useIsCardDroppable_anyCard on AnyCardInterface {
      slug
      openedSo5Lineups {
        id
      }
      liveSo5Lineup {
        id
      }
      signedDropCardPrice {
        price
      }
      ...useTokenBelongsToUser_anyCard
    }
    ${useTokenBelongsToUser.fragments.anyCard}
  ` as TypedDocumentNode<useIsCardDroppable_anyCard>,
};
